import React, { useEffect, useState } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";
import routes from '../../libs/routes';
import images from "../../libs/images";
import * as API from "../../libs/service";
import { useDispatch, useSelector } from 'react-redux';
import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import { open, close } from "../../redux/popupSlice";
import Popup01 from "../../pages/popup/Popup01";
import { ToastContainer, toast, Slide } from 'react-toastify';
import { BrowserView, MobileView, isBrowser } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'react-toastify/dist/ReactToastify.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// ==================== 상수 정의 ====================
const HEADER_TEXT = {
  title: {
    ko: '유니티 하나로 3D 교육까지',
    en: '3D Learning Made Simple'
  },
  subTitle: {
    ko: '속도 UP! 취업 성공 UP! 학생들에게 더 많은 취업 기회를 제공하세요!',
    en: 'Speed Up Learning, Boost Career Success!'
  },
  startButton: {
    ko: '무료로 써보기',
    en: 'Try for Free'
  },
  inquiryButton: {
    ko: '문의하기',
    en: 'Contact Us'
  }
};

const CONTENT_ITEMS = [
  {
    title: { ko: '접근성', en: 'Built for Simplicity' },
    bigTitle: { ko: '쉽게 가르치고, 쉽게 배우세요', en: 'Simple to Teach, Easy to Learn' },
    body: {
      ko: '사용자 친화적인 인터페이스를 통해 초보자도 쉽게 시작할 수 있으며, 고급 기능까지 단계적으로 학습할 수 있어 점진적인 실력 향상이 가능합니다. 또한, 사용 중 어려움이 발생하더라도 전문적인 기술 지원을 제공받아 문제를 신속하게 해결할 수 있어 더욱 원활한 작업 환경을 제공합니다.',
      en: 'A user-friendly interface allows beginners to get started with ease, while advanced features can be learned step by step for continuous skill improvement. Even if challenges arise,  expert technical support ensures quick solutions,  creating a smoother and more efficient workflow.'
    },
    image: require("../../assets/ed_01.webp"),
    reverse: false
  },
  {
    title: { ko: '취업률', en: 'Carrer Opportunities' },
    bigTitle: { ko: '유니티가 열어주는 방대한 취업 기회', en: 'Expand Your Career Potential' },
    body: {
      ko: '프로그래머, 3D 아티스트, 테크니컬 아티스트, VFX 아티스트, 레벨 디자이너, 게임 기획자 등 다양한 분야에서 경험을 쌓고 실력을 향상시킬 수 있는 기회를 제공합니다. 이를 통해 실무에 필요한 역량을 갖추고, 게임 및 콘텐츠 산업에서 취업할 수 있는 가능성을 넓힐 수 있습니다.',
      en: 'Master UModeler X in Unity and gain hands-on experience in  programming, 3D art, VFX, level design, and more. Develop practical  skills to explore career opportunities in gaming and content creation.'
    },
    image: require("../../assets/ed_02.webp"),
    reverse: true
  },
  {
    title: { ko: '효율성', en: 'Efficiency' },
    bigTitle: { ko: '유니티 하나로 준비 완료', en: 'Everything You Need, All in Unity' },
    body: {
      ko: 'UModeler X는 유니티 내에서 모델링부터 리깅, 그리고 페인팅까지 모든 과정을 지원하는 올인원 툴입니다. 별도의 외부 소프트웨어 없이 유니티 환경에서 직접 3D 모델을 제작하고 수정할 수 있어 작업 효율성을 극대화할 수 있으며, 보다 직관적이고 유기적인 워크플로우를 제공합니다.',
      en: 'UModeler X is an all-in-one tool that supports everything  from modeling and rigging to painting—entirely within Unity.  No need for external software—create and edit 3D models  directly inside Unity to maximize efficiency. Enjoy a  more intuitive and seamless workflow tailored for productivity.'
    },
    image: require("../../assets/ed_03.webp"),
    reverse: false
  },
  {
    title: { ko: '다양성', en: 'Limitless Possibilities' },
    bigTitle: { ko: '다양한 분야 활용 가능성', en: 'Endless Possibilities' },
    body: {
      ko: '3D 게임 개발, VR/AR, 메타버스 콘텐츠 제작, 디지털 트윈 등 다양한 분야에서 학습할 기회를 제공하며, 실무 경험을 쌓아 성장할 수 있는 가능성을 열어줍니다. 이를 통해 창작자는 최신 기술을 활용한 다양한 프로젝트를 진행할 수 있으며, 미래의 디지털 환경에서 경쟁력을 갖춘 전문가로 발전할 수 있습니다.',
      en: 'Gain valuable experience in 3D game development, VR/AR,  metaverse content creation, digital twins, and more.  This platform opens up opportunities for hands-on learning and  professional growth, allowing creators to work on cutting-edge  projects and develop expertise in future digital environments.'
    },
    image: require("../../assets/ed_04.webp"),
    reverse: true
  }
];

const PARTNER_TEXT = {
  title: {
    ko: '투자사 및 파트너',
    en: 'Investors and Partners'
  }
};

const BANNER_TEXT = {
  title: {
    ko: '모든 분야를 위한 3D 모델링 교육',
    en: 'Comprehensive 3D Modeling Education'
  },
  inquiryButton: {
    ko: '문의하기',
    en: 'Contact Us'
  },
  startButton: {
    ko: '무료로 써보기',
    en: 'Try for Free'
  }
};

// ==================== 컴포넌트 ====================
export default function Edu() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const lang = useSelector(state => state.langReducer.lang);
  const [supBtnHover, setSupBtnHover] = useState(false);
  const partner_top_sample = 6;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="main_back">
        <div className="main_part padding">
          <div className="header_page_title_box">
            <p className="title">
              {lang === 0 ? HEADER_TEXT.title.ko : HEADER_TEXT.title.en}
            </p>
            <span className="sub_title">
              {lang === 0 ? HEADER_TEXT.subTitle.ko : HEADER_TEXT.subTitle.en}
            </span>
            <div className="btn_box">
              <button
                type="button"
                className={`start ${lang === 1 ? 'eng' : ''}`}
                style={{width: 280}}
                onClick={() => {
                  navigate(routes.Price);
              }}
              >
                {lang === 0 ? HEADER_TEXT.startButton.ko : HEADER_TEXT.startButton.en}
              </button>
              <button
                type="button"
                className={`inquiry ${lang === 1 ? 'eng' : ''}`}
                onClick={() => navigate(routes.Inquiry)}
                style={{width: 280}}
              >
                {lang === 0 ? HEADER_TEXT.inquiryButton.ko : HEADER_TEXT.inquiryButton.en}
              </button>
            </div>
          </div>
          <div className="header_page_content_box">
            {CONTENT_ITEMS.map((item, index) => {
              const contentClass = item.reverse ? "content end" : "content";
              return (
                <div className={contentClass} key={index}>
                  {item.reverse ? (
                    <>
                      <div className="title_box">
                        <div className="top_title">
                          {lang === 0 ? item.title.ko : item.title.en}
                        </div>
                        {item.bigTitle.ko || item.bigTitle.en ? (
                          <p>
                            {lang === 0 ? item.bigTitle.ko : item.bigTitle.en}
                          </p>
                        ) : null}
                        <span style={{ whiteSpace: 'pre-line' }}>
                          {lang === 0 ? item.body.ko : item.body.en}
                        </span>
                      </div>
                      <div className="img_box_169" style={{flex: 1}}>
                        <img src={item.image} alt={`content-${index}`} />
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="img_box_169" style={{flex: 1}}>
                        <img src={item.image} alt={`content-${index}`} />
                      </div>
                      <div className="title_box">
                        <div className="top_title">
                          {lang === 0 ? item.title.ko : item.title.en}
                        </div>
                        {item.bigTitle.ko || item.bigTitle.en ? (
                          <p>
                            {lang === 0 ? item.bigTitle.ko : item.bigTitle.en}
                          </p>
                        ) : null}
                        <span style={{ whiteSpace: 'pre-line' }}>
                          {lang === 0 ? item.body.ko : item.body.en}
                        </span>
                      </div>
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </div>
        <div className="page_start_banner">
          <div className="content">
            <p className="title">
              {lang === 0 ? BANNER_TEXT.title.ko : BANNER_TEXT.title.en}
            </p>
            <div className="btn_box">
              <button
                type="button"
                className={`start ${lang === 1 ? 'eng' : ''}`}
                style={{width: 220}}
                onClick={() => {
                  navigate(routes.Price);
              }}
              >
                {lang === 0 ? BANNER_TEXT.startButton.ko : BANNER_TEXT.startButton.en}
              </button>
              <button
                type="button"
                className={`inquiry ${lang === 1 ? 'eng' : ''}`}
                onClick={() => navigate(routes.Inquiry)}
                style={{width: 220}}
              >
                {lang === 0 ? BANNER_TEXT.inquiryButton.ko : BANNER_TEXT.inquiryButton.en}
              </button>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer
        position="bottom-center"
        transition={Slide}
        limit={1}
        closeButton={false}
        autoClose={1000}
        style={{ width: isBrowser ? 400 : '100%', marginBottom: isBrowser ? 60 : 70 }}
        hideProgressBar
      />
    </>
  );
}